@if (showTable){
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Klant"
                            name="achternaamBelastingplichtige">
      <snelstart-ui-table-col-data>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Fiscaal nummer" name="fiscaalNummer">
      <snelstart-ui-table-col-data>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Middel" name="belastingmiddel">
      <snelstart-ui-table-col-data>
        <ng-template let-belastingmiddel>
          @if (belastingmiddel === 'INKOMSTENBELASTING') {
            <a>Inkomstenbelasting</a>
          } @else if (belastingmiddel === 'VENNOOTSCHAPSBELASTING') {
            <a>Vennootschapsbelasting</a>
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    @if (!datumAutomatischeAanvraag) {
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Aangevraagd" name="datumAanvraag">
        <snelstart-ui-table-col-data>
          <ng-template let-datumAanvraag>
            @if (datumAanvraag === undefined) {
              <a>-</a>
            } @else {
              <a>{{ datumAanvraag | date: 'dd-MM-yyyy' }}</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Uitstel tot"
                              name="datumUitstelTot">
        <snelstart-ui-table-col-data>
          <ng-template let-datumUitstelTot>
            @if (datumUitstelTot === undefined) {
              <a>-</a>
            } @else {
              <a>{{ datumUitstelTot | date: 'dd-MM-yyyy' }}</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Ingeleverd" name="datumIngeleverd">
        <snelstart-ui-table-col-data>
          <ng-template let-datumIngeleverd>
            @if (datumIngeleverd === undefined) {
              <a>-</a>
            } @else {
              <a>{{ datumIngeleverd | date: 'dd-MM-yyyy' }}</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
    } @else {
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Start (boek)jaar"
                              name="boekjaarStart">
        <snelstart-ui-table-col-data>
          <ng-template let-boekjaarStart>
            @if (boekjaarStart === undefined) {
              <a>-</a>
            } @else {
              <a>{{ boekjaarStart | date: 'dd-MM-yyyy' }}</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Einde (boek)jaar"
                              name="boekjaarEind">
        <snelstart-ui-table-col-data>
          <ng-template let-boekjaarEind>
            @if (boekjaarEind === undefined) {
              <a>-</a>
            } @else {
              <a>{{ boekjaarEind | date: 'dd-MM-yyyy' }}</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Soort" name="soortUitstelVerzoek">
        <snelstart-ui-table-col-data>
          <ng-template let-soortUitstelVerzoek>
            @if (soortUitstelVerzoek === 'UITSTELVERZOEK_BECONREGELING') {
              <a>Beconuitstel</a>
            } @else if (soortUitstelVerzoek === 'AANVULLEND_UITSTEL') {
              <a>Aanvullend uitstel</a>
            } @else if (soortUitstelVerzoek === 'AFMELDEN_UITSTEL') {
              <a>Afmelding</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Aangevraagd" name="datumAanvraag">
        <snelstart-ui-table-col-data>
          <ng-template let-datumAanvraag>
            @if (datumAanvraag === undefined) {
              <a>Wordt automatisch aangevraagd voor 1 mei</a>
            }
          </ng-template>
        </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
    }
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Opmerking" name="omschrijving">
      <snelstart-ui-table-col-data>
        <ng-template let-omschrijving>
          @if (omschrijving !== undefined && omschrijving.toLowerCase().includes('afgewezen')) {
            <a>Afgewezen</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('blokkade')) {
            <a>Afgewezen</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('motivering')) {
            <a>Afgewezen</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('onbekend')) {
            <a>Afgewezen</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('lokaal')) {
            <a>Afgewezen</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('er is geen eerder')) {
            <a>Afgewezen</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('geparkeerd')) {
            <a>Uitstel geparkeerd</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('afgemeld')) {
            <a>Klant afgemeld</a>
          } @else if (omschrijving !== undefined && omschrijving.toLowerCase().includes('cvu')) {
            <a>Naar handmatig</a>
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
  </snelstart-ui-table>
}
